import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Placeholder from '../../Placeholder/Placeholder';
import { setVisibleSurveysCount } from '../MarketplaceMatchesActions';
import '../MarketplaceMatchesGrid/MarketplaceMatchesGrid.scss';

const NoResultsAfterSearchingPlaceholder: FC<{ filterText: string | undefined }> = ({ filterText }) => (
    <div id="marketplace-matches__no-matches-container" className="marketplace-matches__no-results-container-search">
        <Placeholder
            className="pxl-text-small pxl-text-muted"
            primaryText={<span>No search results for <b>“ {filterText} ”</b></span>}
            secondaryText="Please try different keywords"
        />
    </div>
);

const NoResultsWithoutFiltersPlaceholder: FC<{ showActiveSurveys: boolean }> = ({ showActiveSurveys }) => (
    <div id="marketplace-matches__no-matches-container" className="marketplace-matches__no-results-container-search">
        <Placeholder
            className="pxl-text-small pxl-text-muted"
            primaryText={<span>{`No ${showActiveSurveys ? 'active' : 'suggested'} marketplace matches found`}</span>}
        />
    </div>
);

const NoResultsAfterFilterPlaceholder = () => (
    <div id="marketplace-matches__no-matches-container" className="marketplace-matches__no-results-container-search">
        <Placeholder
        className="pxl-text-small pxl-text-muted"
        primaryText={<span>There are no marketplace matches based on applied filters</span>}
        secondaryText="Please adjust or clear flters to see matches"
        />
    </div>
)

interface Props {
    noResultsAfterSearching: boolean
    noResultsWithoutFilters: boolean
    searchText: string | undefined
    showActiveSurveys: boolean
}

export const MarketplaceMatchesSlideoutPlaceholder: FC<Props> = ({ noResultsAfterSearching, noResultsWithoutFilters, searchText, showActiveSurveys }) => {
    const dispatch = useDispatch()
    useEffect(() => {
      dispatch(setVisibleSurveysCount(0))
    }, [showActiveSurveys])

    if (noResultsAfterSearching) return <NoResultsAfterSearchingPlaceholder filterText={searchText} />
    if (noResultsWithoutFilters) return <NoResultsWithoutFiltersPlaceholder showActiveSurveys={showActiveSurveys} />
    return <NoResultsAfterFilterPlaceholder />
}